export var getSegment = function (subscription) {
    if (!subscription.plan) {
        return 'free-user';
    }
    if (subscription.status === 'canceled' || new Date(subscription.ends_at) < new Date()) {
        return 'canceled';
    }
    if (subscription.status !== 'active') {
        return subscription.plan + '-' + subscription.status;
    }
    return subscription.plan;
};
